export default __webpack_public_path__ + "static/media/resultDescriptionThumbnail.1474a2c7.png";